import { ApproveStatusEnum } from '../enum/approve-status.enum';
import { NewRequestStatusEnum } from '../enum/request-status.enum';
import { NewRequestTypeEnum } from '../enum/request-step.enum';
import { BarcodeResponse } from './barcode.model';
import { FixtureTypeEnum } from './list-value/list-key-value.model';

export class ShelfRequestListSearchCriteria {
  searchCriteria?: string;
  status?: string;
  requestedDateFrom?: string;
  requestedDateTo?: string;
  requestType?: string;
  shelfType?: string;
  page: number;
  size: number;
}

export class ShelfFixAssetRequestListSearchCriteria {
  searchCriteria?: string;
  status?: string;
  requestedDateFrom?: string;
  requestedDateTo?: string;
  requestType?: string;
  shelfType?: string;
  page: number;
  size: number;
}

export class ShelfRequestListResponse {
  content: ShelfRequestList[];
  empty: boolean;
  first: boolean;
  hasContent: boolean;
  last: boolean;
  numberOfElements: number;
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export class ShelfFixAssetRequestListResponse {
  content: ShelfFixAssetRequestList[];
  empty: boolean;
  first: boolean;
  hasContent: boolean;
  last: boolean;
  numberOfElements: number;
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export class ShelfRequestList {
  id: string;
  requestNo: string;
  shelfType: string;
  shelfName: string;
  requestType: string;
  requestBy: string;
  requestedDate: string;
  requestStatus: NewRequestStatusEnum;
}

export class ShelfFixAssetRequestList {
  id: string;
  requestNo: string;
  requestType: string;
  requestStatus: NewRequestStatusEnum;
  shelfName: string;
  requestBy: string;
  requestedDate: string;
}

export interface ShelfItem {
  barcode: string;
  productName: string;
  unit: string;
  unitFactor: number;
  plg: string;
  facingQty: number;
  stackingQty: number;
  depthQty: number;
  minFirstLotQty: number;
  minBeautyQty: number;
  errorMessage: any;
}

export class RequestId {
  requestId: string;
}

export class ShelfType {
  shelfTypeCode: string;
  shelfTypeName: string;
}

export class ApproveShelfRequest {
  requestNo: string;
  status: ApproveStatusEnum;
  comment: string;
}

export class ShelfCreateRequest {
  id?: string;
  shelfNo?: string;
  no?: string;
  version = 0;
  requestNo?: string;
  shelfCode?: string;
  type: NewRequestTypeEnum;
  status: NewRequestStatusEnum;
  shelfInfo: ShelfInfo;
  nonMerchandiseItem: NonMerchandiseItem[];
  merchandiseItem: MerchandiseItem[];
}

export class ShelfFixAssetCreateRequest {
  id?: string;
  shelfNo?: string;
  no?: string;
  version = 0;
  requestNo?: string;
  shelfCode?: string;
  type: NewRequestTypeEnum;
  status: NewRequestStatusEnum;
  shelfInfo: ShelfInfo;
  items?: NonMerchandiseItem[];
}

export class ShelfFixAssetRequestViewResponse extends ShelfFixAssetCreateRequest {
  requestedBy: string;
  requestedByName: string;
  requestedDate: string;
  deleteItems?: DeleteShelfItems[];
}

export class ShelfRequestViewResponse extends ShelfCreateRequest {
  requestedBy: string;
  requestedByName: string;
  requestedDate: string;
  deleteMerchandiseItem?: DeleteShelfItems[];
  deleteNonMerchandiseItem?: DeleteShelfItems[];
}

export class ShelfInfo {
  shelfName: string;
  shelfType?: string;
  shelfImage: string;
  changes?: ChangesItems[];
}

export class NonMerchandiseItem {
  articleNo: string;
  barcode: string;
  productName: string;
  unit: string;
  unitFactor: number;
  quantity: number;
  productLocation: string;
  changeStatus?: string;
  changes?: ChangesItems[];

  public static mappingBarcodeResponseToNonMerchandiseItem(response: BarcodeResponse): NonMerchandiseItem {
    return {
      barcode: response.barcode,
      articleNo: response.articleNo,
      productName: response.productName,
      productLocation: response.productLocation,
      unit: response.unit,
      unitFactor: response.unitFactor,
      quantity: null
    };
  }
}

export class MerchandiseItem {
  id?: string;
  articleNo: string;
  barcode: string;
  productName: string;
  productGrading: string;
  productLocation: string;
  unit: string;
  unitFactor: number;
  baseUnit?: string;
  plg: string;
  bay: string;
  facingQty: number;
  stackingQty: number;
  depthQty: number;
  minFirstLotQty: number;
  minBeautyQty: number;
  classCode: string;
  changeStatus?: string;
  changes?: ChangesItems[];
  maxRefillQuantity: number;
  bayNo: string;
  bayLevel: string;
  locationId: string;
  fixtureType?: FixtureTypeEnum;

  public static mappingBarcodeResponseToMerchandiseItem(response: BarcodeResponse): MerchandiseItem {
    return {
      articleNo: response.articleNo,
      classCode: response.classCode,
      barcode: response.barcode,
      productName: response.productName,
      productGrading: response.productGrading,
      productLocation: response.productLocation,
      unit: response.unit,
      unitFactor: response.unitFactor,
      baseUnit: response.baseUnit,
      plg: response.productLocation,
      bay: null,
      facingQty: null,
      stackingQty: null,
      depthQty: null,
      minFirstLotQty: null,
      minBeautyQty: null,
      bayNo: null,
      bayLevel: null,
      maxRefillQuantity: null,
      locationId: response.locationId,
      fixtureType: null
    };
  }
}

export class InventoryImportItem {
  barcode: string;
  bay: string;
  facingQty: number;
  stackingQty: number;
  depthQty: number;
  maxRefillQuantity: number;
  product: BarcodeResponse;
  locationId: string;
  fixtureType?: FixtureTypeEnum;
}

export class FirstLotImportItem {
  barcode: string;
  minFirstLotQty: number;
  minBeautyQty: number;
}

export class ChangesItems {
  field: string;
  before: string | number;
  after: string | number;
}

export class ListOfChanges {
  barcode: string;
  bayNo?: string;
  bayLevel?: string;
  locationId?: string;
  changeStatus: string;
  changes: string[];
}

export class DeleteShelfItems {
  barcode: string;
  productName: string;
  unit: string;
  unitFactor: number;
  baseUnit?: string;
}

export class ShelfSelectFixAssetSearchCriteria {
  shelfName?: string;
  status?: string;
  size?: number;
  page?: number;
  sortBy?: string;
  sortOrder?: string;
  wmsCode?: string;
}
